module.exports = __webpack_public_path__ + "static/media/galdisa_productos_proceso.d4e2243e.png";